import React from "react";
import { Dialog } from "@headlessui/react";
import TextInput from "../../TextInput";
import InlineCheckbox from "../../InlineCheckbox";

function PrescriptionRow({ label, rightValues, leftValues }) {
    return (
        <div className="overflow-x-auto">
            <div className="min-w-[620px]">
                <h1 className="text-lg font-medium leading-6 text-gray-900 dark:text-white">
                    {label}
                </h1>
                <div className="mt-4 grid grid-cols-5 gap-4">
                    <p className="mt-7 text-end dark:text-white">OD</p>
                    {rightValues.map((field) => (
                        <TextInput
                            key={field.name}
                            value={field.value}
                            disabled={true}
                            name={field.name}
                            label={field.label}
                            labelClassName="block w-full text-center"
                        />
                    ))}
                    <p className="mt-2 text-end dark:text-white">OI</p>
                    {leftValues.map((field) => (
                        <TextInput
                            key={field.name}
                            value={field.value}
                            disabled={true}
                            name={field.name}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}

export default function LastEyeglassPrescriptionModalContent({
    patient,
    onClose,
}) {
    const prescription = patient?.lastEyeglassPrescription;

    return (
        <>
            <div>
                <div className="mt-3 text-left sm:mt-5">
                    <Dialog.Title
                        as="h3"
                        className="mb-5 text-lg font-semibold leading-6 text-gray-900 dark:text-white"
                    >
                        Ultima graduacion recetada
                    </Dialog.Title>
                    <div className="space-y-8">
                        <PrescriptionRow
                            label="Vision lejana"
                            rightValues={[
                                { name: "farVisionSphericalRight", label: "Esf", value: prescription?.farVisionSphericalRight },
                                { name: "farVisionCylindricalRight", label: "Cil.", value: prescription?.farVisionCylindricalRight },
                                { name: "farVisionAxisRight", label: "Eje", value: prescription?.farVisionAxisRight },
                                { name: "farVisionVisualAcuityRight", label: "Av.", value: prescription?.farVisionVisualAcuityRight },
                            ]}
                            leftValues={[
                                { name: "farVisionSphericalLeft", value: prescription?.farVisionSphericalLeft },
                                { name: "farVisionCylindricalLeft", value: prescription?.farVisionCylindricalLeft },
                                { name: "farVisionAxisLeft", value: prescription?.farVisionAxisLeft },
                                { name: "farVisionVisualAcuityLeft", value: prescription?.farVisionVisualAcuityLeft },
                            ]}
                        />

                        <PrescriptionRow
                            label="Vision cercana"
                            rightValues={[
                                { name: "nearVisionSphericalRight", label: "Esf", value: prescription?.nearVisionSphericalRight },
                                { name: "nearVisionCylindricalRight", label: "Cil.", value: prescription?.nearVisionCylindricalRight },
                                { name: "nearVisionAxisRight", label: "Eje", value: prescription?.nearVisionAxisRight },
                                { name: "nearVisionVisualAcuityRight", label: "Av.", value: prescription?.nearVisionVisualAcuityRight },
                            ]}
                            leftValues={[
                                { name: "nearVisionSphericalLeft", value: prescription?.nearVisionSphericalLeft },
                                { name: "nearVisionCylindricalLeft", value: prescription?.nearVisionCylindricalLeft },
                                { name: "nearVisionAxisLeft", value: prescription?.nearVisionAxisLeft },
                                { name: "nearVisionVisualAcuityLeft", value: prescription?.nearVisionVisualAcuityLeft },
                            ]}
                        />

                        <div>
                            <h1 className="mb-4 text-lg font-medium leading-6 text-gray-900 dark:text-white">
                                Tratamiento
                            </h1>
                            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
                                <InlineCheckbox value={prescription?.photochromic} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="photochromic" label="Fotocromatico" />
                                <InlineCheckbox value={prescription?.monofocal} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="monofocal" label="Monofocal" />
                                <InlineCheckbox value={prescription?.antiGlare} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="antiGlare" label="Antireflejo" />
                                <InlineCheckbox value={prescription?.bifocal} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="bifocal" label="Bifocal" />
                                <InlineCheckbox value={prescription?.uvx} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="uvx" label="UVX" />
                                <InlineCheckbox value={prescription?.multifocal} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="multifocal" label="Multifocal" />
                                <InlineCheckbox value={prescription?.focalFilter} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="focalFilter" label="Filtro azul" />
                                <InlineCheckbox value={prescription?.wideField} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="wideField" label="Campo Amplio" />
                                <InlineCheckbox value={prescription?.contactLens} className="input-base h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary" disabled={true} name="contactLens" label="Lente de contacto" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="mt-5 sm:mt-6">
                <button
                    type="button"
                    className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 sm:mt-0 sm:text-sm"
                    onClick={onClose}
                >
                    Volver
                </button>
            </div>
        </>
    );
}
